import { createAction, props } from '@ngrx/store';
import { LocalOptionValue } from 'src/app/core/local-option-value';

// Cache check actions (entry point for components)
export const getSettingsOptionsCache = createAction('[Settings Options] fetch cache check');
export const getSettingsOptionsCacheHit = createAction('[Settings Options] fetch from cache');

// Actual fetch action (API call)
export const getSettingsOptions = createAction('[Settings Options] fetch settings options');

export const getSettingsOptionsSuccess = createAction(
  '[Settings Options] fetch settings success',
  props<{ settingsOptions: LocalOptionValue[] } >()
);

export const getSettingsOptionsError = createAction(
  '[Settings Options] fetch settings error',
  props<{ error: any }>()
);

export const updateSettingsOptions = createAction(
  '[Settings Options] update settings options',
  props<{ option: LocalOptionValue }>()
);

export const updateSettingsOptionsSuccess = createAction(
  '[Settings Options] update settings options success',
  props<{ option: LocalOptionValue }>()
);

export const updateSettingsOptionsError = createAction(
  '[Settings Options] update settings options error',
  props<{ error: any }>()
);
